/**
 * Document Helpers
 *
 * This file contains helper functions for document operations.
 * These are pure functions that don't depend on Redux runtime.
 */

import {
    applyDesignatorMappingToElement,
    DesignatorMapping,
    remapDesignatorsToAvoidDuplicates,
} from "@buildwithflux/core";
import {IElementData, IPartVersionData} from "@buildwithflux/models";
import {cloneDeep} from "lodash";

/**
 * Helper function to update an element to use a new part version.
 * Includes designator remapping, if there are conflicts.
 */
export function updateElementToUsePartVersion(params: {
    element: IElementData;
    partVersionData: IPartVersionData;
    otherDesignatorsAlreadyInProject: string[];
}) {
    // NOTE: very important to clone this object. Easy to forget and make weird bugs!!!
    params.element.part_version_data_cache = cloneDeep(params.partVersionData);

    // If the element was already remapped before, apply that mapping again
    const previousMapping = params.element.designatorMappings
        ? new DesignatorMapping(params.element.designatorMappings)
        : undefined;
    if (previousMapping) {
        applyDesignatorMappingToElement({
            element: params.element,
            mapping: previousMapping,
        });
        // Note: there may be designator conflicts *within* the part now, i.e. if *new* elements were added
        // in the latest part version. This should be handled in remapDesignators below.
    }

    // Remap any designators that need to change to avoid conflicts in host project
    remapDesignatorsToAvoidDuplicates({
        elementToRemap: params.element,
        designatorsToAvoid: params.otherDesignatorsAlreadyInProject,
    });
}
